import React from 'react';
import hashHistory from '@src/History';
import PropTypes from 'prop-types';
// import Icon from 'components/Icon';
import SupermanIcon from '@src/components/Icon/superman.svg';
import { isNewPipeline } from '@src/actions/_utils';

import Icon from 'relements/build/esm/ui/icon';
import styles from './Breadcrumbs.scss';

/**
 * Breadcrumbs navigation component
 * Renders a set of links/breadcrumbs based on the crumbs prop
 * @type {Array}
 */
export default class Breadcrumbs extends React.Component {
  static propTypes = {
    meta: PropTypes.object,
    crumbs: PropTypes.arrayOf(PropTypes.object),
  };

  render() {
    let { crumbs = [] } = this.props;
    crumbs = crumbs.filter(crumb => !!crumb.title);
    return (
      <div className={styles.breadcrumbs}>
        <Icon
          onClick={this._navToHome}
          src="home"
          className={styles.breadcrumbsIcon}
        />

        {crumbs.map((crumb, i) => {
          const isSuperman = isNewPipeline(crumb);
          return (
            <React.Fragment key={i}>
              <Icon src="angle-down" className={styles.breadCrumbsSeparator} />
              <span
                onClick={() => this._navToPage(crumb)}
                className={styles.breadcrumbsText}
              >
                {crumb.title}
              </span>
              {isSuperman ? (
                <Icon
                  className={styles.superman}
                  src={SupermanIcon}
                  tooltip="Superman Pipeline"
                  tooltipPosition="TOP"
                />
              ) : null}
            </React.Fragment>
          );
        })}
      </div>
    );
  }

  /**
   * On clicking on any breadcrumb, we navigate to the appropriate page
   * linked to the breadcrumb
   * @param  {[type]} crumb [description]
   * @return {[type]}       [description]
   */
  _navToPage = crumb => {
    const { id, route, key } = crumb;

    if (key === 'botId') {
      const url = `/bot/${id}`;
      hashHistory.push(url);
    } else if (key === 'storyId') {
      const url = route
        .replace(':botId', this.props.meta.domain.id)
        .replace(':storyId', id);
      hashHistory.push(url);
    } else if (!key) {
      hashHistory.push(route);
    }
  };

  /**
   * On clicking the home icon we navigate to the homepage
   * @return {[type]} [description]
   */
  _navToHome = () => {
    hashHistory.push('/');
  };
}
